(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["app_faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var items = document.querySelectorAll('.faq__item');
    items.forEach(function(item) {
      var btn = item.querySelector('.faq__question');
      var answer = item.nextElementSibling;
      btn.addEventListener('click', function() {
        var isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open');
        answer.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', !isOpen);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["app_header"]) return;
  try {
    
  (function() {
    var hamburger = document.querySelector('.header__hamburger');
    var drawer = document.querySelector('.drawer');
    var overlay = document.querySelector('.drawer-overlay');
    var closeBtn = document.querySelector('.drawer__close');

    function openDrawer() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (hamburger) hamburger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
  })();

  } catch(e) { console.error(e); }
})();
})();
